import firebase from '@/firebase'
import { FS_COLLECTIONS } from '@/firebase'
import { URL_CLUDSF } from '@/constantes/environment'
import axios from "axios";
const storage = firebase.storage().ref()
const db = firebase.firestore()
import { obtenerDetallesPagosTicket } from '@/constantes/saldo/index.js'

var cargaCatalogoCasos = null;
var cargaCatalogoServiciosCasos = null;

const sleep = ms => new Promise(r => setTimeout(r, ms));


const store = {
  state: {
    listaCasos: {},
    listaServiciosCasos: [],
    listaServiciosCasosCopia: {},
    listaCasosGeneral: {},
    listaServiciosCasosGeneral: [],
    caso: {},
    serviciosCasos: {},
    servicioCasoSeleccionado: {},
    serviciosCasosPropietario: {},
    estadoArchivo: {},
    tieneEvidenciaPorSubir: false,
  },
  getters: {
    tieneEvidenciaPorSubir: state => {
      return state.tieneEvidenciaPorSubir
    },
    listaCasos: state => {
      return state.listaCasos
    },
    listaCasosGeneral: state => {
      return state.listaCasosGeneral;
    },
    listaServiciosCasosGeneral: state => {
      return state.listaServiciosCasosGeneral;
    },
    listaServiciosCasos: state => {
      return state.listaServiciosCasos
    },
    listaServiciosCasosCopia: state => {
      return state.listaServiciosCasosCopia
    },
    caso: state => {
      return state.caso
    },
    serviciosCasos: state => {
      return state.serviciosCasos;
    },
    serviciosCasosPropietario: state => {
      return state.serviciosCasosPropietario;
    },
    servicioCasoSeleccionado: state => {
      return state.servicioCasoSeleccionado;
    },
    estadoArchivo: state => {
      return state.estadoArchivo
    },
  },
  mutations: {
    ASIGNA_CATALOGO_CASOS(state, listaCasos) {
      state.listaCasos = listaCasos
    },
    ASIGNA_CATALOGO_CASOS_GENERAL(state, listaCasosGeneral) {
      state.listaCasosGeneral = listaCasosGeneral;
    },
    ASIGNA_CATALOGO_SERVICIOS_CASOS_GENERAL(state, listaServiciosCasosGeneral) {
      state.listaServiciosCasosGeneral = listaServiciosCasosGeneral;
    },
    ASIGNA_CATALOGO_SERVICIOCASOS(state, listaServiciosCasos) {
      state.listaServiciosCasos = listaServiciosCasos
    },
    ASIGNA_CATALOGO_SERVICIOCASOS_COPIA(state, listaServiciosCasos) {
      state.listaServiciosCasosCopia = listaServiciosCasos
    },
    ASIGNA_CASO(state, caso) {
      state.caso = caso
    },
    ASIGNA_SERVICIO_CASO_PROPIETARIO(state, servicio) {
      state.serviciosCasosPropietario = servicio;
    },
    ASIGNA_SERVICIO_CASO_SELECCIONADO(state, caso) {
      state.servicioCasoSeleccionado = caso;
    },
    ASIGNA_ESTADO_ARCHIVO(state, archivo) {
      state.estadoArchivo = archivo
    },
    ASIGNA_TIENE_EVIDENCIA_POR_SUBIR(state, tieneEvidenciaPorSubir) {
      state.tieneEvidenciaPorSubir = tieneEvidenciaPorSubir
    },
  },
  actions: {
    restablecerValoresCasos({ commit }) {
      commit('ASIGNA_CASO', {})
      commit('ASIGNA_CATALOGO_CASOS', {})
    },
    restablecerValoresServiciosCasos({ commit }) {
      commit('ASIGNA_CASO', {})
      commit('ASIGNA_CATALOGO_CASOS', {})
      commit('ASIGNA_CATALOGO_SERVICIOCASOS', [])
      commit('ASIGNA_SERVICIO_CASO_SELECCIONADO', {})
      commit('ASIGNA_SERVICIOS_POR_CATEGORIA', {})
      commit('ASIGNA_SERVICIOS_POR_SUBCATEGORIA', {})
      commit('ASIGNA_SERVICIOS_POR_PRINCIPALES', {})
      commit('ASIGNA_SERVICIOS_POR_PRINCIPALES_GENERAL', {})
      commit('ASIGNA_PRODUCTOS_POR_CATEGORIA', {})
      commit('ASIGNA_PRODUCTOS_POR_SUBCATEGORIA', {})
      commit('ASIGNA_PRODUCTOS_POR_LINEA', {})
      commit('ASIGNA_PRODUCTOS_POR_PRINCIPALES', {})
    },
    actualizarServiciosHospitalizacion({ }, id_franquicia) {

      var batch = db.batch();

      db.collection(FS_COLLECTIONS.FRANQUICIAS)
        .doc(id_franquicia).collection("ServiciosCasos")
        .where("tipo", "==", "Hospitalización").get().then(querySnapshot => {

          if (querySnapshot.empty)
            return false;

          querySnapshot.forEach((doc) => {
            // doc.data() is never undefined for query doc snapshots
            //console.log(doc.id, " => ", doc.data());
            if (doc.data().tipo == "Hospitalización") {
              if (doc.data().actualizado === undefined) {
                console.log("Actualiza servicio", doc.id)
                let ref = db.collection(FS_COLLECTIONS.FRANQUICIAS).doc(id_franquicia)
                  .collection("ServiciosCasos").doc(doc.id)
                batch.set(ref, { actualizado: true }, { merge: true })
              }
            }
          })

          batch.commit().then(() => {
            console.log("TODOS LOS SERVICIOS HAN SIDO ACTUALIZADOS")

          }).catch(error => {
            console.log("Ocurrió un error en el batch", error)
          })
        })
    },
    cargaResponsableParaReceta({ }, id_responsable) {
      return new Promise((resolve, reject) => {
        let docPath = db.collection(FS_COLLECTIONS.USUARIOS).doc(id_responsable)
        docPath.get().then(doc => {
          resolve(doc.data())
        }).catch(error => {
          reject(error)
        })
      })
    },
    actualizarCaso({ getters }, caso) {
      const casoObj = JSON.parse(JSON.stringify(caso));
      //caso.fecha = new Date()
      const idCaso = casoObj.id;
      delete casoObj.id;

      casoObj.id_usuario_modifico = getters.usuario.id;
      return new Promise((resolve, reject) => {
        db.collection(FS_COLLECTIONS.CASOS)
          .doc(idCaso)
          .update(casoObj).then(() => {
            resolve(true);
          }).catch(error => {
            reject(error);
          })
      })
    },
    agregarCaso({ getters }, caso) {
      caso.fecha = new Date()
      caso.id_franquicia = getters.franquicia.id;
      caso.id_usuario_modifico = getters.usuario.id;
      caso.activo = true
      caso.anio = caso.fecha.getFullYear();
      caso.mes = ("0" + (caso.fecha.getMonth() + 1)).slice(-2);
      return new Promise((resolve, reject) => {
        db.collection(FS_COLLECTIONS.CASOS)
          .add(caso)
          .then(docRefServicio => {
            console.log("Store crea un caso")
            console.log(docRefServicio.id)
            resolve(docRefServicio)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    agregarCasoPropietario({ getters, dispatch }, id_caso) {
      console.log("AGREGAR CASO PROPIETARIO STORE" + id_caso);
      var propietarios = getters.pacienteActual.propietarios;
      for (var i in propietarios) {
        let docPath = db
          .collection(FS_COLLECTIONS.PROPIETARIOS)
          .doc(propietarios[i]);
        docPath.get().then(doc => {
          console.log("Propietario seleccionado")
          var propietario = {};
          propietario = doc.data();
          propietario.casos.push(id_caso);
          dispatch('actualizarPropietario', propietario);
          console.log(propietario)
        });
      }
    },
    cargaCaso({ commit }, idCaso) {
      return new Promise((resolve) => {
        let docPath = db.collection(FS_COLLECTIONS.CASOS).doc(idCaso)
        docPath.get().then(doc => {
          commit('ASIGNA_CASO', doc.data())
          resolve(doc.data())
        })
      })
    },
    cargaCatalogoCasosStatic({ commit }, paciente) {
      return new Promise((resolve) => {
        let docPath = db
          .collection(FS_COLLECTIONS.PACIENTES)
          .doc(paciente)
          .collection(FS_COLLECTIONS.INDICES)
          .doc(FS_COLLECTIONS.CASOS)
          docPath.get().then(doc => {
            let casos = doc.exists ? doc.data() : [];
            resolve(casos)
          })
      })
    },
    cargaCatalogoCasos({ commit }, paciente) {
      return new Promise((resolve) => {
        let docPath = db
          .collection(FS_COLLECTIONS.PACIENTES)
          .doc(paciente)
          .collection(FS_COLLECTIONS.INDICES)
          .doc(FS_COLLECTIONS.CASOS)
        cargaCatalogoCasos = docPath.onSnapshot(doc => {
          commit('ASIGNA_CATALOGO_CASOS', doc.data())
          resolve(doc.data())
        })
      })
    },
    cargaCatalogoCasosGeneral({ commit, getters }, fechas) {
      const { anio, mes } = fechas;
      // console.log("🚀 ~ file: casos.js ~ line 213 ~ cargaCatalogoCasosGeneral ~ getters.franquicia.id", getters.franquicia.id)
      // console.log("🚀 ~ file: casos.js ~ line 212 ~ cargaCatalogoCasosGeneral ~ mes", mes)
      // console.log("🚀 ~ file: casos.js ~ line 212 ~ cargaCatalogoCasosGeneral ~ anio", anio)
      // return new Promise((resolve) => {
      //   let docPath = db
      //     .collection(FS_COLLECTIONS.FRANQUICIAS)
      //     .doc(getters.franquicia.id)
      //     .collection(FS_COLLECTIONS.CASOS_INDICES)
      //     .doc(anio+'')
      //   docPath.onSnapshot(doc => {
      //     let casos = doc.exists ? doc.data() : {};
      //     console.log("🚀 ~ file: casos.js ~ line 219 ~ returnnewPromise ~ casos", casos)
      //     commit('ASIGNA_CATALOGO_CASOS_GENERAL', casos)
      //     resolve(casos)
      //   })
      // })

      return new Promise((resolve,reject) => {
        let docPath = db
          .collection(FS_COLLECTIONS.FRANQUICIAS)
          .doc(getters.franquicia.id)
          .collection('Casos_Indices_v2')
          .where("anio", "==", parseInt(anio))
          .where("mes", "==", mes);
          // console.log("ref indice casos general",`${FS_COLLECTIONS.FRANQUICIAS}/${getters.franquicia.id}/Casos_Indices_v2`,`Mes == ${mes} && Anio == ${anio}`);
        let casos = {};
        // console.log("ejecuta antes de obtener en tiempo real info")
        docPath.get().then(function (querySnapshot) {
          // console.log("obtiene docs", querySnapshot,querySnapshot.size)
          querySnapshot.forEach(function (doc) {
            let data = doc.data();
            //data.data.id = doc.id;


            for (let i in data.lista_ids) {
              casos[i] = data.lista_ids[i];
            }
            //console.log(doc.id, ' => ', doc.data());
          });

          console.log("🚀 ~ file: casos.js ~ line 239 ~ casos", casos)

          commit('ASIGNA_CATALOGO_CASOS_GENERAL', casos)
          resolve(casos)
        }).catch(function (error) {
          console.error("Error getting documents: ", error);
          reject(error);
        });
      })


    },

    updateCollection({ }, colleccion) {

      return new Promise((resolve, reject) => {
        //db.collection("Propietarios").where("franquicia", "==", "869Yd7ghWgELZb5EjGuL")
        db.collection("Pacientes").get().then((querySnapshot) => { //Mantenimientos

          const listaPacientes = {}
          querySnapshot.forEach(doc => {
            const pacientes = doc.data() || {}

            listaPacientes[doc.id] = {
              ...pacientes,
              id: doc.id,
            }

          });
          resolve(listaPacientes);
        });

      })
    },

    async actualizarVersion({ }, idDoc) {
      return db
        .collection('Pacientes')
        .doc(idDoc)
        .set({ version: '19agosto2022-1.5' }, { merge: true });
    },


    cargaCatalogoServiciosCasosGeneral({ commit, getters }, anio) {
      return new Promise((resolve) => {
        let docPath = db
          .collection(FS_COLLECTIONS.FRANQUICIAS)
          .doc(getters.franquicia.id)
          .collection('ServiciosCasos_Indices')
          .doc(anio + '')
        docPath.onSnapshot(doc => {
          commit('ASIGNA_CATALOGO_SERVICIOS_CASOS_GENERAL', doc.data())
          resolve(doc.data())
        })
      })
    },
    cargaCatalogoServiciosCasos({ commit }, caso) {
      return new Promise((resolve) => {
        let docPath = db
          .collection(FS_COLLECTIONS.CASOS)
          .doc(caso)
        cargaCatalogoServiciosCasos = docPath.onSnapshot(doc => {
          console.log("Carga catalogo servicios casos ", doc.data())
          commit('ASIGNA_CATALOGO_SERVICIOCASOS', doc.data())
          commit('ASIGNA_CATALOGO_SERVICIOCASOS_COPIA', JSON.parse(JSON.stringify(doc.data() || {})))
          //console.log("ServiciosCasos desde el store");
          //console.log(doc.data());
          resolve(doc.data())
        })
      });
    },
    obtenerServicioCaso({ commit }, caso) {
      return new Promise((resolve) => {
        let docPath = db
          .collection(FS_COLLECTIONS.CASOS)
          .doc(caso)
        cargaCatalogoServiciosCasos = docPath.onSnapshot(doc => {
          resolve(doc.data())
        })
      });
    },
    obtenerCatalogoServiciosCasos({ commit, dispatch, getters }, casos) {
      return new Promise((resolve) => {
        var lista_casos = [];
        for (var i in casos) {
          let docPath = db
            .collection(FS_COLLECTIONS.CASOS)
            .doc(casos[i])
          cargaCatalogoServiciosCasos = docPath.onSnapshot(doc => {
            var resp = doc.data();
            if (resp.activo) {
              if (resp.servicios_caso !== undefined) {
                var item = resp.servicios_caso
                for (var i in item) {
                  lista_casos.push(item[i]);
                }
              }
            }
            //console.log(lista_casos)
          })
          //console.log("ASIGNA SERVICIO_CASO_PROPIETARIO" + lista_casos.length)
          //console.log(lista_casos)
          commit('ASIGNA_SERVICIO_CASO_PROPIETARIO', lista_casos)
          resolve(lista_casos);
        }
      });

    },
    cargaServicioCasoSeleccionado({ getters }, id_servicio_caso) {
      return new Promise((resolve, reject) => {
        db.collection(FS_COLLECTIONS.FRANQUICIAS)
          .doc(getters.franquicia.id)
          .collection(FS_COLLECTIONS.SERVICIOS_CASOS)
          .doc(id_servicio_caso).get().then(doc => {
            //commit('ASIGNA_SERVICIO_CASO_SELECCIONADO',doc.data());
            //console.log("Respuesta mandada desde el store");
            console.log("Data store servicio ", doc.data())
            resolve(doc.data())
          }).catch(error => {
            reject(error)
          })
      });
    },
    subirArchivoPDF({ getters }, { archivo, nombre }) {
      return new Promise((resolve, reject) => {
        var f = new Date();
        var anio = f.getFullYear();
        var mes = f.getMonth();
        var dia = f.getDay();

        var d = f.getTime()
        var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx'.replace(/[xy]/g, function (c) {
          var r = (d + Math.random() * 16) % 16 | 0
          d = Math.floor(d / 16)
          return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16)
        })
        console.log("Subir archivo receta desde store")
        var archivoSubir = archivo.name;
        console.log(archivoSubir)
        storage
          .child(`Archivos/${getters.franquicia.id}/${nombre}/${anio}-${mes}-${dia}/${uuid}/${archivoSubir}`)
          .put(archivo)
          .then(uploadTaskSnapshot => {
            uploadTaskSnapshot.ref
              .getDownloadURL()
              .then(url => {
                console.log("URL AL GUARDAR")
                console.log(url)
                resolve(url)
              })
              .catch(error => reject(error))
          })
          .catch(error => reject(error))
      })
    },
    actualizarServicioCaso({ getters }, servicio_caso) {
      servicio_caso.data.id_usuario_modifico = getters.usuario.id;
      return db
        .collection(FS_COLLECTIONS.FRANQUICIAS)
        .doc(getters.franquicia.id)
        .collection("ServiciosCasos")
        .doc(servicio_caso.id_caso_seleccionado)
        .update(servicio_caso.data);
    },
    eliminarServicioCaso({ getters }, servicio_caso) {
      servicio_caso.data.servicio_generico.activo = false;
      console.log(servicio_caso.data)
      servicio_caso.data.id_usuario_modifico = getters.usuario.id;
      return db
        .collection(FS_COLLECTIONS.FRANQUICIAS)
        .doc(getters.franquicia.id)
        .collection("ServiciosCasos")
        .doc(servicio_caso.id)
        .update(servicio_caso.data);
    },
    guardaServicioCaso2({ getters, dispatch }, data) {
      console.log("DDatos del store servicio caso al guardar", data)
      //return false;
      //console.log(data);
      return new Promise(async (resolve, reject) => {
      if (data.servicio.servicio_generico.tiene_plan !== undefined) {
        if (Object.keys(data.servicio.servicio_generico.descuento).length > 0) {
          console.log("Este servicio tiene un plan de bienestar asociado")
          let docPath = db.collection(FS_COLLECTIONS.PACIENTES).doc(data.id_paciente)
          docPath.get().then(doc => {
            var nuevoPlan = doc.data();
            var id = data.servicio.servicio_generico.descuento.id_personal;
            for (var i in nuevoPlan.plan_bienestar.plan_actual.items) {
              if (nuevoPlan.plan_bienestar.plan_actual.items[i].id_personal == id) {
                
                const consumidoActual = parseInt(data.servicio.servicio_generico.cantidad);
                console.log("🚀 ~ file: casos.js:460 ~ docPath.get ~ consumidoActual", consumidoActual)
                const limitePlan = parseInt(nuevoPlan.plan_bienestar.plan_actual.items[i].cantidad);
                console.log("🚀 ~ file: casos.js:462 ~ docPath.get ~ limitePlan", limitePlan)
                if(consumidoActual >= limitePlan){
                  nuevoPlan.plan_bienestar.plan_actual.items[i].vecesConsumido = limitePlan;
                }else{
                  nuevoPlan.plan_bienestar.plan_actual.items[i].vecesConsumido += consumidoActual;
                }
                

                if (nuevoPlan.plan_bienestar.plan_actual.items[i].vecesConsumido
                  == nuevoPlan.plan_bienestar.plan_actual.items[i].cantidad) {
                  nuevoPlan.plan_bienestar.plan_actual.items[i].fecha_consumido = new Date();
                }
                db.collection(FS_COLLECTIONS.PACIENTES)
                  .doc(data.id_paciente)
                  .update(nuevoPlan).then(() => {
                    //
                  }).catch(error => {
                    reject(error)
                  })
              }
            }
          }).catch(error => {
            reject(error)
          })
          /*if(data.servicio.servicio_generico.tiene_descuento!=undefined){
            let docPath = db.collection(FS_COLLECTIONS.FRANQUICIAS)
            .doc(getters.franquicia.id).collection(FS_COLLECTIONS.DESCUENTOS)
            .doc(data.servicio.servicio_generico.descuento.id_descuento);
            docPath.get().then(doc => {
              var nuevo_descuento = doc.data();
              for(var i in nuevo_descuento.items.elementos){
                if(nuevo_descuento.items.elementos[i].id==data.servicio.servicio_generico.descuento.id){
                  nuevo_descuento.items.elementos[i].usado = true;
                  db.collection(FS_COLLECTIONS.FRANQUICIAS)
                  .doc(getters.franquicia.id).collection(FS_COLLECTIONS.DESCUENTOS)
                  .doc(data.servicio.servicio_generico.descuento.id_descuento).update(nuevo_descuento);
                }
              }
            });
          } else {
            
          }*/
        }
      }
      //Desconectar el monedero del propietario
      if (data.servicio.servicio_generico.monedero.aplica) {
        console.log("Cantidad nueva del monedero")
        console.log(data.servicio.servicio_generico.monedero.cantidad)
        let docPath = db.collection(FS_COLLECTIONS.PROPIETARIOS).doc(getters.propietarioActual.id);
        docPath.get().then(doc => {
          let nuevo_propietario = doc.data();
          nuevo_propietario.monedero = data.servicio.servicio_generico.monedero.cantidad;
          db.collection(FS_COLLECTIONS.PROPIETARIOS)
            .doc(getters.propietarioActual.id)
            .update(nuevo_propietario).then(() => {
              //
            }).catch(error => {
              reject(error)
            })
        })
      }
      

        const { id_almacen } = getters.usuario

        if (id_almacen) {
          data.servicio.id_almacen = id_almacen
          console.log("Guardar id almacen en servicio ", id_almacen)
        }

        data.servicio.id_usuario_modifico = getters.usuario.id;
        data.servicio.usuario_registro = getters.usuario.id;

        //SE TIENE QUE OBTENER EL ID DEL PROPIETARIO POSICION 1 DEL ARRAY DEL DOC DEL PACIENTE por que el state causa problemas - marco salazar
        const datosPacientes = await dispatch('getDocPaciente', data.servicio.id_paciente)
        data.servicio.id_propietario_getter_oldversion = data.servicio.id_propietario; //ESTE ES EL QUE NO SE GUARDABA BIEN AVECES, PARA TENER REGISTRO NADA MAS
        data.servicio.id_propietario = datosPacientes.propietarios[0];


        db.collection(FS_COLLECTIONS.FRANQUICIAS)
          .doc(getters.franquicia.id).collection("ServiciosCasos")
          .add(data.servicio)
          .then(docRefServicio => {
            console.log("🚀 ~ returnnewPromise ~ ServiciosCasos id:", docRefServicio.id)
            resolve(docRefServicio)
          })
          .catch(error => {
            reject(error)
          })
      })
          
    },
   
    getDocPaciente({  }, idPaciente) {
      if (!idPaciente) return
      return new Promise((resolve, reject) => {
        let docPath = db.collection(FS_COLLECTIONS.PACIENTES).doc(idPaciente)
        docPath.get().then(doc => {
          resolve(doc.data())
        })
      })

    },

    existeEvidenciaSinSubir({ commit }, tieneEvidenciaSubida) {
      console.log("🚀 ~ existeEvidenciaSinSubir ~ tieneEvidenciaSubida:", tieneEvidenciaSubida)
      commit('ASIGNA_TIENE_EVIDENCIA_POR_SUBIR', tieneEvidenciaSubida)
    },
    subirEvidenciaCaso({ dispatch }, data) {
      return new Promise(async (resolve, reject) => {
        var evidencias = data.evidencias
        console.log("🚀 ~ returnnewPromise ~ evidencias:", evidencias)
        var promises = [];
        for (var i in evidencias) {
          var dataEvidencia = {
            idCaso: data.idCaso,
            idServicioCaso: data.idServicioCaso,
            evidencia: evidencias[i],
          }
          promises.push(await dispatch('subirArchivosEvidencias', dataEvidencia));
        }
        await Promise.all(promises).then(async respuesta => {
          console.log("Respuesta ", respuesta)
          var dataEvidencia = {
            idCaso: data.idCaso,
            idServicioCaso: data.idServicioCaso,
            evidencias: respuesta,
            ruta: data.ruta || null
          }
          await dispatch('actualizarEvidenciasServiciosCasos', dataEvidencia).then(() => {
            resolve()
          }).catch(error => {
            reject(error)
          })
        }).catch(error => {
          reject(error)
          console.log(error)
        })
      })
    },
    actualizarEvidenciasServiciosCasos({ getters }, datos) {
      return new Promise((resolve, reject) => {

        console.log("Actualiar evidencias datos ", datos)
        let obj = {}
        for (var i in datos.evidencias) {
          var item = datos.evidencias[i];
          obj[item.id] = item;
        }

         // Construir la estructura anidada
         const dataToUpdate = datos.ruta 
         ? { [datos.ruta]: { evidencias: obj } } 
         : { evidencias: obj };

        db.collection(FS_COLLECTIONS.FRANQUICIAS)
          .doc(getters.franquicia.id)
          .collection("ServiciosCasos")
          .doc(datos.idServicioCaso).set(dataToUpdate, { merge: true }).then(() => {
            resolve(true)
          }).catch(error => {
            reject(error);
          })

      })
    },
    subirArchivosEvidencias({ getters, commit }, datos) {
      return new Promise(async (resolve, reject) => {
        var { idCaso, idServicioCaso, evidencia } = datos;
        //console.log("🚀 ~ returnnewPromise ~ evidencia333:", evidencia)
        if (evidencia.subida) {
          resolve(evidencia)
          return null
        }

        //console.log("subirArchivosEvidencias putString", evidencia.ruta_archivo)

        const strImageBase64 = evidencia.ruta_archivo.split(',');
        

        // Verificar si el texto comienza con 'https'
        if (strImageBase64[0].startsWith("https")) {
          resolve(evidencia)
          return false
        }

        console.log("🚀 ~ file: casos.js ~ line 570 ~ returnnewPromise ~ strImageBase64", strImageBase64[0])
        let imagenOptimizada = '';
        if(evidencia.tipo != "application/pdf"){

          const dataJsonImg = JSON.stringify({ imagen: strImageBase64[1] });
          let urlCloud = URL_CLUDSF + '/wsOptimizarImg';

          const res = await axios.post(urlCloud, dataJsonImg, {
            headers: {
              'Content-Type': 'application/json'
            }
          });
          console.log('respuesta imagenOptimizada', res);

          imagenOptimizada = strImageBase64[0] +','+ res.data.resultData
          console.log("🚀 ~ file: casos.js ~ line 583 ~ returnnewPromise ~ imagenOptimizada", imagenOptimizada)
        }else{
          imagenOptimizada = strImageBase64[0] +','+ strImageBase64[1];
        }


        storage
          .child(`Franquicias/${getters.franquicia.id}/casos/${idCaso}/ServiciosCasos/${idServicioCaso}/${evidencia.id}`)
          .putString(imagenOptimizada, 'data_url', { contentType: evidencia.tipo !== null ? evidencia.tipo : 'image/jpg' }).then((resp) => {
            resp.ref
              .getDownloadURL()
              .then(url => {
                let evidenciaObj = {}
                evidenciaObj = evidencia;
                evidenciaObj.ruta_archivo = url;
                console.log("esta es la rita", evidenciaObj.ruta_archivo)
                evidenciaObj.fecha_registro = new Date();
                evidenciaObj.subida = true;
                console.log("Evidencia nueva ", evidenciaObj);
                commit('ASIGNA_ESTADO_ARCHIVO', {
                  title: "Bien hecho!",
                  body: `Su archivo ${evidenciaObj.nombre} ha sido subido correctamente`,
                  url: evidenciaObj.ruta_archivo,
                  tipo: evidenciaObj.tipo,
                })
                resolve(evidenciaObj)
              })
              .catch(error => {
                commit('ASIGNA_ESTADO_ARCHIVO', {
                  title: "Error",
                  body: `Ocurrió un error al intentar su archivo ${evidenciaObj.nombre}`,
                  url: evidenciaObj.ruta_archivo,
                  tipo: evidenciaObj.tipo,
                })
                reject(error)
              })
          }).catch(error => reject(error));
      })
    },
    eliminarEvidencias({ getters }, data) {
      return new Promise((resolve, reject) => {
        var { idCaso, idServicioCaso } = data
        var url = `Franquicias/${getters.franquicia.id}/Casos/${idCaso}/ServiciosCasos/${idServicioCaso}`
        console.log("url evid ", url);
        var storageRef = storage.child(url)
        storageRef
          .delete()
          .then(resp => {
            resolve(resp)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    actualizarEstatusServicioCaso({ getters }, idServicioCaso) {

      return new Promise((resolve, reject) => {
        db.collection(FS_COLLECTIONS.FRANQUICIAS)
          .doc(getters.franquicia.id)
          .collection(FS_COLLECTIONS.SERVICIOS_CASOS)
          .doc(idServicioCaso).set({ info: { estatusVencimiento: "Enviado", } }, { merge: true }).then(() => {
            resolve(true)
          }).catch(error => {
            reject(error);
          })

      })
    },

    /*METODOS 2021*/

    eliminarTicketDeServicio({ getters }, props) {

      const { id_servicio_caso, id_ticket, ticket } = props

      return new Promise((resolve, reject) => {

        const pagosPendientes = ticket.pagos_pendientes.filter(e => e.id_servicio_caso !== id_servicio_caso)

        const data = {
          pagos_pendientes: pagosPendientes,
          ...obtenerDetallesPagosTicket(pagosPendientes, ticket.pagos_realizados),
        }
        //Si es un ticket sin pagos ni servicios entonces lo borramos de forma lógica
        if (data.pagos_pendientes.length === 0) {
          data.activo = false;
          console.log("Ticket ", id_ticket, " pasa a inacvtivo")
        }

        db.collection(FS_COLLECTIONS.FRANQUICIAS).doc(getters.franquicia.id)
          .collection(FS_COLLECTIONS.TICKETS).doc(id_ticket).update(data).then(() => {
            resolve()
          }).catch(e => {
            reject(e)
          })

      })

    },
    actualizarAnticiposPropietario({ }, props) {

      const { id_propietario, anticipos } = props

      return new Promise((resolve, reject) => {

        db.collection(FS_COLLECTIONS.PROPIETARIOS).doc(id_propietario)
          .update({ "anticipos": anticipos }).then(() => {
            resolve()
          }).catch(error => {
            reject(error)
          })

      })

    },



    //
    // actualizarPagos({getters},campoCompletado){
    //   //console.log("🚀 ~ file: casos.js ~ line 601 ~ actualizarPagos ~ campoCompletado", campoCompletado)
    //   //const key = campoCompletado.key;
    //   const key = 0;

    //   return new Promise((resolve,reject) => {


    //     db.collection(FS_COLLECTIONS.FRANQUICIAS)
    //     .doc(getters.franquicia.id)
    //     .collection(FS_COLLECTIONS.TICKETS)
    //     .doc(campoCompletado.idTicket)
    //     .update({pagos_pendientes: campoCompletado.pagos_pendientes});


    //     resolve(true);
    //   })
    // }

  }
}

export default store



// WEBPACK FOOTER //
// ./src/store/casos/casos.js